export default __webpack_public_path__ + "static/media/00.6d7f3d83.jpg";